import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./styles.css"
/** entry point for the app */
ReactDOM.createRoot(document.getElementById("root") as HTMLElement).render(
  <App/>
);